import * as React from 'react';
import devWarning from '../_util/devWarning';
import { changeConfirmLocale } from '../modal/locale';
import LocaleContext from './context';
export const ANT_MARK = 'internalMark';
let LocaleProvider = /** @class */ (() => {
    class LocaleProvider extends React.Component {
        constructor(props) {
            super(props);
            changeConfirmLocale(props.locale && props.locale.Modal);
            if (process.env.NODE_ENV !== 'production')
                devWarning(props._ANT_MARK__ === ANT_MARK, 'LocaleProvider', '`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale');
        }
        componentDidUpdate(prevProps) {
            const { locale } = this.props;
            if (prevProps.locale !== locale) {
                changeConfirmLocale(locale && locale.Modal);
            }
        }
        componentWillUnmount() {
            changeConfirmLocale();
        }
        render() {
            const { locale, children } = this.props;
            return (<LocaleContext.Provider value={Object.assign(Object.assign({}, locale), { exist: true })}>{children}</LocaleContext.Provider>);
        }
    }
    LocaleProvider.defaultProps = {
        locale: {},
    };
    return LocaleProvider;
})();
export default LocaleProvider;
